import {useEffect} from 'react';

export const useDeepEffect = (callback: () => void, dependencies: unknown[]) => {
    useEffect(callback, dependencies);
};
